/**
 * MDLR Events
 *
 * Central location for all event names used throughout the application.
 * This prevents typos and makes events easier to find and refactor.
 *
 * Instead of hardcoding event strings like 'CART:CHANGED' everywhere,
 * we use these constants: MDLR.EVENTS.CART.CHANGED
 *
 * Usage:
 *   window.MDLR.dispatchEvent(window.MDLR.EVENTS.CART.CHANGED, data)
 *   window.MDLR.eventBus.addEventListener(
 *     window.MDLR.EVENTS.CART.CHANGED,
 *     handler
 *   )
 */

window.MDLR = window.MDLR || {};

window.MDLR.EVENTS = {
  // Cart-related events
  CART: {
    // Fired before adding item from form
    BEFORE_ADD_FROM_FORM: "CART:BEFORE_ADD_FROM_FORM",

    // Fired after adding item from form
    AFTER_ADD_FROM_FORM: "CART:AFTER_ADD_FROM_FORM",

    // Fired before adding item(s)
    BEFORE_ADD: "CART:BEFORE_ADD",

    // Fired after adding item(s)
    AFTER_ADD: "CART:AFTER_ADD",

    // Fired before updating item quantity
    BEFORE_UPDATE_ITEM_QUANTITY: "CART:BEFORE_UPDATE_ITEM_QUANTITY",

    // Fired after updating item quantity
    AFTER_UPDATE_ITEM_QUANTITY: "CART:AFTER_UPDATE_ITEM_QUANTITY",

    // Fired before removing item(s)
    BEFORE_REMOVE_ITEM: "CART:BEFORE_REMOVE_ITEM",

    // Fired after removing item(s)
    AFTER_REMOVE_ITEM: "CART:AFTER_REMOVE_ITEM",

    // Fired before updating cart attributes
    BEFORE_UPDATE_CART_ATTRIBUTES: "CART:BEFORE_UPDATE_CART_ATTRIBUTES",

    // Fired after updating cart attributes
    AFTER_UPDATE_CART_ATTRIBUTES: "CART:AFTER_UPDATE_CART_ATTRIBUTES",

    // Fired before changing cart note
    BEFORE_CHANGE_NOTE: "CART:BEFORE_CHANGE_NOTE",

    // Fired after changing cart note
    AFTER_CHANGE_NOTE: "CART:AFTER_CHANGE_NOTE",

    // Fired whenever the cart state changes for any reason
    CHANGED: "CART:CHANGED",
  },

  // Product-related events
  PRODUCT: {
    // Fired when a product variant is selected
    VARIANT_SELECTED: "PRODUCT:VARIANT_SELECTED",

    // Fired when add-to-cart form is submitted
    ADD_TO_CART: "PRODUCT:ADD_TO_CART",
  },

  // Modal/Dialog events
  MODAL: {
    // Fired when a modal opens
    OPENED: "MODAL:OPENED",

    // Fired when a modal closes
    CLOSED: "MODAL:CLOSED",
  },

  // Search-related events
  SEARCH: {
    // Fired when search results are loaded
    RESULTS_LOADED: "SEARCH:RESULTS_LOADED",

    // Fired when search is cleared
    CLEARED: "SEARCH:CLEARED",
  },

  // Navigation events
  NAVIGATION: {
    // Fired when page navigation begins (e.g., link clicked)
    STARTING: "NAVIGATION:STARTING",

    // Fired when page navigation completes
    COMPLETED: "NAVIGATION:COMPLETED",
  },
};
